export default __webpack_public_path__ + "81d371037ba7eeced62a89309f1bb6bc.svg";